import { useEffect, useState } from "react";

// Check initial desktop state based on window.matchMedia if available
const getInitialDesktopState = (): boolean => {
  if (typeof window === "undefined" || !window.matchMedia) {
    return false;
  }
  const mq = window.matchMedia("(min-width: 1024px)");
  return mq?.matches ?? false;
};

const useIsDesktop = (): boolean => {
  const [isDesktop, setIsDesktop] = useState<boolean>(getInitialDesktopState);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) {
      return;
    }

    const mq = window.matchMedia("(min-width: 1024px)");
    if (!mq) {
      return;
    }
    setIsDesktop(mq.matches);

    const handler = (e: MediaQueryListEvent) => {
      setIsDesktop(e.matches);
    };

    mq.addEventListener("change", handler);
    return () => {
      mq.removeEventListener("change", handler);
    };
  }, []);
  return isDesktop;
};

export default useIsDesktop;
